import React, { useState } from 'react';
// Petit bouton picto pour copier une adresse. stopPropagation (ne déclenche pas le onClick de ligne).
export default function CopyBtn({ text, title = "Copier l'adresse" }) {
  const [ok, setOk] = useState(false);
  if (!text) return null;
  const copy = (e) => {
    e.stopPropagation();
    try { navigator.clipboard?.writeText(text); } catch {}
    setOk(true); setTimeout(() => setOk(false), 1000);
  };
  return (
    <button type="button" onClick={copy} title={title}
      style={{ background:'none', border:'none', cursor:'pointer', padding:'0 2px', marginLeft:4,
               color: ok ? '#22c55e' : 'var(--text2)', fontSize:12, lineHeight:1, verticalAlign:'middle' }}>
      {ok ? '✓' : '⧉'}
    </button>
  );
}
